module.exports = __webpack_public_path__ + "img/entertainment-m-3.5c6c8b4a.jpg";